const incidentEnumerators = {
  //incidentType: ['Injury', 'Illness', 'NearMiss', 'PropertyDamage', 'Environmental', 'Vehicle', 'Other'],
  initialClassification: ['WorkAccident', 'CommutingAccident', 'OccupationalDisease', 'NotCoveredByLaw', 'NotApplicable'],
  finalClassification: ['WorkAccident', 'CommutingAccident', 'OccupationalDisease', 'NotCoveredByLaw', 'NotApplicable'],
  severity: ['Mild', 'Severe', 'Fatal', 'MINSAL', 'PotentiallySevere', 'Other'], // TODO: 'Event' de momento no va, no agregar aún
  incidentStatus: ['Open', 'Rejected', 'Closed', 'Accepted'],
  withLostDaysSelector: ['yes', 'no'],
  contractType: ['Unspecified', 'Indefinite', 'FixedTerm', 'ProjectBased', 'Obra o Faena', 'Obra', 'Renovación Automática', 'Other'],
  entryType: ['ProcessContinuity', 'NewEntry', 'ReEntry'],
  injuryType: ['Cut', 'Burn', 'Contusion', 'Other'],
  weekday: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
  accionesSubestandar: [
    'Operar equipo sin autorización',
    'No cumplir PTS',
    'Falta de conocimiento',
    'Posturas inadecuadas',
    'Falta de destreza',
    'Mal uso de herramientas',
    'No usar EPP',
    'Falta de atención',
  ],
  condicionesSubestandar: [
    'Falta de advertencias',
    'Falta de equipos de seguridad',
    'Plataforma de trabajo en mal estado',
    'Falta de orden y aseo',
    'Maquinas en mal estado',
    'Malas condiciones climáticas',
    'Almacenaje defectuoso',
    'Pisos en mal estado',
  ],
  tipoAccidente: [
    'Golpeado contra',
    'Caída mismo nivel',
    'Atrición equipo/estructura',
    'Caída distinto nivel',
    'Contacto con químico/temperatura',
    'Golpeado con',
    'Atrapamiento',
  ],
  origin: [
    null,
    'Undetermined',
    'Attrition',
    'SameLevelFall',
    'FallFromDifferentLevel',
    'ContactWithElectricalEnergy',
    'ContactWithCuttingMaterial',
    'ContactWithChemicalSubstance',
    'ContactWithHotObject',
    'StruckBy',
    'StruckAgainst',
    'InjuryCausedByAnimals',
    'RepetitiveMotion',
    'Overexertion',
    'AscensoControlado',
    'EscapeLibre',
    'Trapping',
    'Crushing',
    'RunOver',
    'FallDifferentLevel',
    'FallSameLevel',
    'ContactShell',
    'ContactChemicalProducts',
    'ContactHotSurfaces',
    'ContactCuttingSurfaces',
    'ContactColdSurfaces',
    'ContactHotLiquids',
    'ForeignBody',
    'PowerLines',
    'ManualMaterialHandling',
    'Stabbing',
    'Covid19',
    'Psychological',
    'Commuting',
    'OccupationalDisease',
    'ContactWithSpines',
    'FoodPoisoning',
    'CapsizeBoat',
  ],
  managementBlumar: {
    'Blumar S.A.': ['Gerencia Operaciones', 'Subgerencia Logística'],
    'Pesquera Bahía Caldera S.A.': ['Gerencia Operaciones'],
    'Salmones Blumar Magallanes Spa': ['Gerencia Farming', 'Gerencia Procesamiento Salmones'],
    'Salmones Blumar S.A.': ['Gerencia Farming', 'Gerencia Procesamiento Salmones'],
  },
  zonaAfectada: {
    Cabeza: [
      'Cuero cabelludo, cráneo, cerebro y nervios y vasos sanguíneos del cráneo',
      'Oreja(s)',
      'Ojo(s)',
      'Diente(s)',
      'Otros sitios específicos de la región facial',
      'Cabeza, lesiones múltiples',
      'Cabeza, otros sitios específicos no clasificados bajo otros epígrafes',
      'Cabeza, sitio no especificado',
    ],
    'Cuello, incluidas la médula espinal y las vértebras cervicales': [
      'Médula espinal y vértebras',
      'Cuello, otros sitios específicos, no clasificados bajo otros epígrafes',
      'Cuello, sitio no especificado',
    ],
    'Espalda, incluidas la médula espinal y las vértebras dorsales': [
      'Médula espinal y vértebras',
      'Espalda, otros sitios no clasificados bajo otros epígrafes',
      'Espalda, sitio no especificado',
    ],
    'Torso y órganos internos': [
      'Tórax (inclusive las costillas, el esternón y los omóplatos)',
      'Otros sitios del tórax (inclusive los órganos internos)',
      'Región pelviana y abdominal (inclusive los órganos internos)',
      'Órganos genitales externos',
      'Torso, lesiones múltiples',
      'Torso, otros sitios específicos no clasificados bajo otros epígrafes',
      'Torso y órganos internos, sitio no especificado',
    ],
    'Miembros superiores': [
      'Hombro y articulación escapulohumeral',
      'Brazo, incluido el codo',
      'Muñeca',
      'Mano',
      'Pulgar',
      'Otro(s) dedo(s)',
      'Miembros superiores, lesiones múltiples',
      'Miembros superiores, otros sitios específicos no clasificados bajo otros epígrafes',
      'Miembros superiores, sitio no especificado',
    ],
    'Miembros inferiores': [
      'Cadera y articulación coxofemoral',
      'Pierna, incluida la rodilla',
      'Tobillo',
      'Pie',
      'Dedo(s) del pie',
      'Miembros inferiores, lesiones múltiples',
      'Miembros inferiores, otros sitios específicos no clasificados bajo otros epígrafes',
      'Miembros inferiores, sitio no especificado',
    ],
    'Todo el cuerpo y sitios anatómicos lesionados múltiples': [
      'Efectos sistémicos (como, por ejemplo, los producidos por envenenamiento o infección)',
      'Múltiples sitios anatómicos afectados',
    ],
    'Otras partes del cuerpo lesionadas': [],
    'Parte del cuerpo lesionada no especificada': [],
  },
  riesgo: {
    'Caída de personas': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Caída de personas',
        riesgo: 'Caídas al mismo nivel',
        definicion: 'Caída que se produce en el mismo plano de sustentación.',
        codigo: 'A1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Caída de personas',
        riesgo: 'Caídas a distinto nivel',
        definicion: 'Caída a un plano inferior desde menos de 1.8 mts.',
        codigo: 'A2',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Caída de personas',
        riesgo: 'Caídas de altura',
        definicion: 'Caída a un plano inferior desde más de 1.8 mts.',
        codigo: 'A3',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Caída de personas',
        riesgo: 'Caídas al agua',
        definicion: 'Caída a un curso de agua natural o estructura con agua.',
        codigo: 'A4',
      },
    ],
    'Contacto con objetos': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con objetos',
        riesgo: 'Atrapamiento',
        definicion: 'Enganche o aprisionamiento del cuerpo por mecanismos.',
        codigo: 'B1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con objetos',
        riesgo: 'Caída de objetos',
        definicion: 'Caída de elementos que golpean al cuerpo.',
        codigo: 'B2',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con objetos',
        riesgo: 'Cortes por objetos/herramientas cortopunzantes',
        definicion: 'Cortes y/o punzaciones por objetos cortantes, punzantes o abrasivos.',
        codigo: 'B3',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con objetos',
        riesgo: 'Choque contra objetos',
        definicion: 'Encuentro violento del cuerpo con objetos, en movimiento o no.',
        codigo: 'B4',
      },
    ],
    'Contacto con seres vivos': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con seres vivos',
        riesgo: 'Contacto con personas',
        definicion: 'Lesiones por acción de otras personas.',
        codigo: 'C1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con seres vivos',
        riesgo: 'Contacto con animales y/o insectos',
        definicion: 'Lesiones por interacción con animales y/o insectos.',
        codigo: 'C2',
      },
    ],
    'Contactos térmicos': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contactos térmicos',
        riesgo: 'Contactos térmicos por calor',
        definicion: 'Contacto físico con superficies o productos calientes.',
        codigo: 'E1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contactos térmicos',
        riesgo: 'Contactos térmicos por frío',
        definicion: 'Contacto físico con superficies o productos fríos.',
        codigo: 'E2',
      },
    ],
    'Contacto con energía eléctrica': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con energía eléctrica',
        riesgo: 'Contactos eléctricos directos baja tensión',
        definicion: 'Contacto directo con partes activas en tensión (<1000 volts).',
        codigo: 'F1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con energía eléctrica',
        riesgo: 'Contactos eléctricos directos alta tensión',
        definicion: 'Contacto directo con partes activas en tensión (>1000 volts).',
        codigo: 'F2',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con energía eléctrica',
        riesgo: 'Contactos eléctricos indirectos baja tensión',
        definicion: 'Contacto con masas accidentalmente en tensión (<1000 volts).',
        codigo: 'F3',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con energía eléctrica',
        riesgo: 'Contactos eléctricos indirectos alta tensión',
        definicion: 'Contacto con masas accidentalmente en tensión (>1000 volts).',
        codigo: 'F4',
      },
    ],
    'Contacto con sustancias químicas': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con sustancias químicas',
        riesgo: 'Contacto con sustancias cáusticas y/o corrosivas',
        definicion: 'Contacto con sustancias cáusticas que causan lesiones en la piel.',
        codigo: 'G1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con sustancias químicas',
        riesgo: 'Contacto con otras sustancias químicas',
        definicion: 'Contacto con sustancias no cáusticas que causan lesiones en la piel.',
        codigo: 'G2',
      },
    ],
    'Contacto con elementos que se proyectan': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con elementos que se proyectan',
        riesgo: 'Explosiones',
        definicion: 'Liberación brusca de energía que genera presión y calor.',
        codigo: 'H1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con elementos que se proyectan',
        riesgo: 'Proyección de fragmentos y/o partículas',
        definicion: 'Contacto violento con fragmentos proyectados como piezas o partículas.',
        codigo: 'H2',
      },
    ],
    'Contacto con/en Vehículos en movimiento': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con/en Vehículos en movimiento',
        riesgo: 'Atropellos o golpes con vehículos',
        definicion: 'Impacto entre peatón y vehículo en movimiento.',
        codigo: 'I1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Contacto con/en Vehículos en movimiento',
        riesgo: 'Choque, colisión o volcamiento',
        definicion: 'Lesiones por choque, colisión o volcamiento de vehículos.',
        codigo: 'I2',
      },
    ],
    Incendios: [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Incendios',
        riesgo: 'Incendios',
        definicion: 'Fuego incontrolado que genera lesiones por gases o altas temperaturas.',
        codigo: 'J',
      },
    ],
    'Exposición a condiciones atmosféricas extremas': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Exposición a condiciones atmosféricas extremas',
        riesgo: 'Exposición a ambientes con deficiencia de oxígeno',
        definicion: 'Exposición a atmósfera con déficit de oxígeno (<19.5%).',
        codigo: 'K1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Exposición a condiciones atmosféricas extremas',
        riesgo: 'Exposición a sustancias químicas tóxicas',
        definicion: 'Exposición a atmósfera con altas concentraciones de químicos tóxicos.',
        codigo: 'K2',
      },
    ],
    'Exposición a altos niveles de radiación': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Exposición a altos niveles de radiación',
        riesgo: 'Exposición a radiaciones no ionizantes',
        definicion: 'Exposición a altas dosis de radiaciones no ionizantes (UV, IR, etc.).',
        codigo: 'L1',
      },
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Exposición a altos niveles de radiación',
        riesgo: 'Exposición a radiaciones ionizantes',
        definicion: 'Exposición a altas dosis de radiaciones ionizantes (rayos X, gamma).',
        codigo: 'L2',
      },
    ],
    'Ingesta de sustancias nocivas': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Ingesta de sustancias nocivas',
        riesgo: 'Ingesta de sustancias nocivas',
        definicion: 'Ingesta de sustancias que alteran la salud del trabajador.',
        codigo: 'M',
      },
    ],
    'Otros riesgos': [
      {
        tipo: 'RIESGOS DE SEGURIDAD',
        familia: 'Otros riesgos',
        riesgo: 'Otros riesgos',
        definicion: 'Riesgos no descritos en ítems anteriores.',
        codigo: 'N',
      },
    ],
    'Exposición a agentes químicos': [
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes químicos',
        riesgo: 'Exposición a aerosoles sólidos',
        definicion: 'Permanencia en ambientes con partículas sólidas en suspensión.',
        codigo: 'O1',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes químicos',
        riesgo: 'Exposición a aerosoles líquidos',
        definicion: 'Permanencia en ambientes con partículas líquidas en suspensión.',
        codigo: 'O2',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes químicos',
        riesgo: 'Exposición a gases y vapores',
        definicion: 'Permanencia en ambientes con sustancias en estado gaseoso.',
        codigo: 'O3',
      },
    ],
    'Exposición a agentes físicos': [
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes físicos',
        riesgo: 'Exposición a ruido',
        definicion: 'Permanencia en ambientes con altos niveles de presión sonora.',
        codigo: 'P1',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes físicos',
        riesgo: 'Exposición a Vibraciones',
        definicion: 'Permanencia en ambientes con energía vibratoria transferida al cuerpo.',
        codigo: 'P2',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes físicos',
        riesgo: 'Exposición a Radiaciones Ionizantes',
        definicion: 'Permanencia en ambientes con radiaciones ionizantes.',
        codigo: 'P3',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes físicos',
        riesgo: 'Exposición a Radiaciones No Ionizantes',
        definicion: 'Permanencia en ambientes con radiaciones no ionizantes.',
        codigo: 'P4',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes físicos',
        riesgo: 'Exposición a Calor',
        definicion: 'Permanencia en ambientes con altas temperaturas.',
        codigo: 'P5',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes físicos',
        riesgo: 'Exposición a Frío',
        definicion: 'Permanencia en ambientes con bajas temperaturas.',
        codigo: 'P6',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes físicos',
        riesgo: 'Exposición a Altas presiones',
        definicion: 'Permanencia en ambientes con presiones superiores a la atmosférica.',
        codigo: 'P7',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes físicos',
        riesgo: 'Exposición a Bajas presiones',
        definicion: 'Permanencia en ambientes con presiones inferiores a la atmosférica.',
        codigo: 'P8',
      },
    ],
    'Exposición a agentes biológicos': [
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes biológicos',
        riesgo: 'Transmisión por sangre y fluidos',
        definicion: 'Inoculación de agentes biológicos por sangre o fluidos.',
        codigo: 'Q1',
      },
      {
        tipo: 'RIESGOS HIGIÉNICOS',
        familia: 'Exposición a agentes biológicos',
        riesgo: 'Transmisión aérea, hídrica y por contacto',
        definicion: 'Exposición a agentes biológicos por transmisión aérea, hídrica o por contacto.',
        codigo: 'Q2',
      },
    ],
    'Manejo o Manipulación Manual de Carga (MMC) o Personas (MMP)': [
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Manejo o Manipulación Manual de Carga (MMC) o Personas (MMP)',
        riesgo: 'Sobrecarga física debido a la manipulación manual de cargas',
        definicion: 'Trabajos que implican levantar, descender o transportar manualmente objetos de más de 3 kg.',
        codigo: 'R1',
      },
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Manejo o Manipulación Manual de Carga (MMC) o Personas (MMP)',
        riesgo: 'Sobrecarga física debido a la manipulación de personas/pacientes',
        definicion: 'Trabajos que implican manejo manual de personas/pacientes.',
        codigo: 'R2',
      },
    ],
    'Trabajo repetitivo de la extremidad superior': [
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Trabajo repetitivo de la extremidad superior',
        riesgo: 'Sobrecarga física debido al trabajo repetitivo de las extremidades superiores',
        definicion: 'Tareas que implican movimientos repetitivos de las extremidades superiores.',
        codigo: 'S1',
      },
    ],
    'Sobrecarga Postural (postura mantenida y/o forzada)': [
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Sobrecarga Postural (postura mantenida y/o forzada)',
        riesgo: 'Sobrecarga Postural debido a trabajo de pie',
        definicion: 'Trabajos en posición bípeda permanente con escasa alternancia postural.',
        codigo: 'T1',
      },
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Sobrecarga Postural (postura mantenida y/o forzada)',
        riesgo: 'Sobrecarga Postural debido a trabajo sentado',
        definicion: 'Trabajos en posición sentado mantenido por períodos prolongados.',
        codigo: 'T2',
      },
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Sobrecarga Postural (postura mantenida y/o forzada)',
        riesgo: 'Sobrecarga Postural debido a trabajo en cuclillas (agachado)',
        definicion: 'Trabajos en posición de cuclillas por tiempos prolongados.',
        codigo: 'T3',
      },
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Sobrecarga Postural (postura mantenida y/o forzada)',
        riesgo: 'Sobrecarga Postural debido a trabajo arrodillado',
        definicion: 'Trabajos que implican compresión directa sobre las rodillas sostenidamente.',
        codigo: 'T4',
      },
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Sobrecarga Postural (postura mantenida y/o forzada)',
        riesgo: 'Sobrecarga Postural debido a tronco inclinado, en torsión o lateralización',
        definicion: 'Trabajos con posturas del tronco fuera del rango neutro o de confort.',
        codigo: 'T5',
      },
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Sobrecarga Postural (postura mantenida y/o forzada)',
        riesgo: 'Sobrecarga Postural debido a trabajo fuera del alcance funcional',
        definicion: 'Trabajos que implican movimientos fuera del alcance funcional.',
        codigo: 'T6',
      },
      {
        tipo: 'RIESGOS MÚSCULO ESQUELÉTICOS',
        familia: 'Sobrecarga Postural (postura mantenida y/o forzada)',
        riesgo: 'Sobrecarga Postural debido a otras posturas',
        definicion: 'Otras posturas no definidas en los ítems anteriores.',
        codigo: 'T7',
      },
    ],
    'Riesgos Psicosociales Laborales': [
      {
        tipo: 'RIESGOS PSICOSOCIALES LABORALES',
        familia: 'Riesgos Psicosociales Laborales',
        riesgo: 'Exigencias psicológicas en el trabajo',
        definicion: 'Involucra exigencias emocionales, creativas y cuantitativas.',
        codigo: 'D1',
      },
      {
        tipo: 'RIESGOS PSICOSOCIALES LABORALES',
        familia: 'Riesgos Psicosociales Laborales',
        riesgo: 'Trabajo activo y desarrollo de habilidades',
        definicion: 'Se refiere a la autonomía del trabajador sobre su trabajo.',
        codigo: 'D2',
      },
      {
        tipo: 'RIESGOS PSICOSOCIALES LABORALES',
        familia: 'Riesgos Psicosociales Laborales',
        riesgo: 'Apoyo social en la empresa y calidad del liderazgo',
        definicion: 'Calidad del apoyo social y liderazgo dentro de la empresa.',
        codigo: 'D3',
      },
      {
        tipo: 'RIESGOS PSICOSOCIALES LABORALES',
        familia: 'Riesgos Psicosociales Laborales',
        riesgo: 'Compensaciones',
        definicion: 'Equilibrio entre esfuerzo y recompensas, estabilidad del empleo.',
        codigo: 'D4',
      },
      {
        tipo: 'RIESGOS PSICOSOCIALES LABORALES',
        familia: 'Riesgos Psicosociales Laborales',
        riesgo: 'Doble presencia',
        definicion: 'Preocupación por cumplir con tareas domésticas y laborales.',
        codigo: 'D5',
      },
    ],
  },
  causasInmediatas: {
    'Acciones subestandar': [
      'N/A',
      'Operar equipos o maquinas sin autorizacion',
      'No señalar o advertir',
      'Falta en asegurar adecuadamente',
      'Operar a una velocidad inadecuada',
      'Hacer inoperantes los dispositivos de seguridad',
      'Usar equipo defectuoso',
      'Usar incorrectamente el elemento de protección personal',
      'Carga inadecuada',
      'Almacenamiento inadecuado',
      'Levantamiento inadecuado',
      'Posición de tarea inadecuada',
      'Realizar mantención de equipos en operación',
      'Hacer bromas',
      'Trabajar bajo la influencia del alcohol y/o otras drogas',
      'Uso inapropiado del equipo',
      'No cumplir procedimientos e instrucciones',
    ],
    'Condiciones subestandar': [
      'N/A',
      'Protecciones o barreras inadecuadas',
      'Elemento de protección personal inadecuado o defectuoso',
      'Herramientas, equipos o materiales inadecuados o defectuosos',
      'Congestión o acción restringida',
      'Sistema de advertencia inadecuada',
      'Peligro de incendio o explosión',
      'Orden y limpieza deficiente',
      'Exposición al ruido',
      'Exposición a radiaciones',
      'Exposición a temperaturas extremas',
      'Iluminación inadecuada',
      'Ventilación inadecuada',
      'Condiciones ambientales adversas, polvo, lluvia, viento, humo',
      'Presencia de gases toxicos',
    ],
  },
  causasBasicas: {
    'Factores personales': {
      'N/A': [],
      'Capacitación Fisica Inadecuada': [
        'Altura, peso, talla, fuerza, alcance, etc., inadecuada',
        'Movimiento corporal limitado',
        'Capacidad limitada para mantener posiciones del cuerpo',
        'Sensibilidad a sustancias o alergias',
        'Sensibilidad a sensaciones extremas (temperatura, ruido, etc)',
        'Deficiencia visual',
        'Deficiencia auditiva',
        'Otra deficiencia sensorial (tacto, gusto, olfato, equilibrio)',
        'Incapacidad respiratoria',
        'Otras incapacidades físicas permanentes',
        'Incapacidades temporales',
        'Lesión o enfermedad',
        'Fatiga por carga de trabajo o duración del mismo',
      ],
      'Tensión Fisica o Fisiologica': [
        'Fatiga por falta de descanso',
        'Exposición a temperaturas extremas',
        'Insuficiencia de oxígeno',
        'Limitación de movimiento',
        'Insuficiencia de azúcar en la sangre',
        'Alcohol y drogas',
      ],
      'Capacidad Mental/Psicologica Inadecuada': [
        'Miedos y fobias',
        'Perturbación emocional',
        'Exceso de confianza',
        'Incapacidad para comprender y aprender',
        'Mal juicio, acción temeraria o arreglada',
        'Mala coordinación',
        'Reacción lenta',
        'Falta de memoria u olvidadizo',
      ],
      'Tensión Mental / Psicologica': [
        'Sobrecarga emocional o preocupación por problemas',
        'Fatiga por carga o velocidad de tarea mental',
        'Demandas extremas de opinión o decisión',
        'Rutina o monotonía de trabajos no importantes',
        'Demandas extremas de concentración',
        'Actividades sin sentido o degradantes',
        'Direcciones y demandas confusas',
        'Peticiones conflictivas',
        'Frustración',
        'Enfermedad mental',
      ],
      'Falta de Conocimiento': [
        'Falta de experiencia',
        'Orientación inadecuada',
        'Capacitación inicial inadecuada',
        'Actualización inadecuada de conocimientos',
        'Instrucciones mal interpretadas',
      ],
      'Falta de Habilidad': ['Práctica insuficiente', 'Ejecución poco frecuente', 'Falta de preparación o asesoramiento'],
      'Motivación Inadecuada': [
        'Tolerancia del desempeño inadecuado',
        'Falta de incentivos',
        'Frustración excesiva',
        'Agresión inapropiada',
        'Intento inapropiado de ahorrar tiempo y esfuerzo',
        'Intento inapropiado para captar la atención',
        'Disciplina inadecuada',
        'Presión inapropiada de los compañeros de trabajo',
        'Ejemplo inadecuado por parte de la supervisión',
        'Refuerzo deficiente del comportamiento adecuado',
        'Incentivos inadecuados a la producción',
      ],
    },
    'Factores del trabajo': {
      'N/A': [],
      'Liderazgo y/o supervición inadecuada': [
        'Relaciones jerárquicas poco claras o conflictivas',
        'Asignación de responsabilidad poco clara o conflictiva',
        'Delegación insuficiente o inadecuada',
        'Entregar, políticas, procedimientos o pautas de acción inadecuadas',
        'Entregar objetivos, metas o normas contradictorias',
        'Planificación o programación del trabajo inadecuada',
        'Instrucción / orientación y/o preparación deficiente',
        'Documentos, instrucciones y publicaciones inadecuados',
        'Identificación y evaluación deficientes de las exposiciones al riesgo',
        'Falta de conocimiento del trabajo a nivel de supervisión / administración',
        'Asignación inadecuada del trabajador, a las exigencias de la tarea',
        'Medición y evaluación inadecuada del desempeño',
        'Retroalimentación deficiente o inadecuada del desempeño',
      ],
      'Ingenieria inadecuada': [
        'Evaluación inadecuada del riesgo',
        'Consideración deficiente de factores humanos / ergonómico',
        'Estándares, especificaciones y/o criterios de diseños deficientes',
        'Control inadecuado de la construcción',
        'Controles inadecuados',
        'Monitoreo u operación inicial inadecuada',
        'Evaluación inadecuada del cambio',
      ],
      'Compras inadecuadas': [
        'Especificaciones deficientes de ordenes y pedidos',
        'Investigación inadecuada de materiales / equipos',
        'Especificaciones inadecuadas a vendedores',
        'Inspección de recepción y aceptación deficientes',
        'Comunicación inadecuada de la información de seguridad y salud',
        'Manejo, almacenamiento y transporte inadecuado de materiales',
        'Identificación deficiente de productos peligrosos',
        'Disposición inadecuada de residuos y desperdicios',
        'Selección inadecuada de proveedores',
      ],
      'Mantenimiento inadecuado': [
        'Evaluación de necesidades preventivas inadecuadas',
        'Lubricación y servicio preventivo inadecuado',
        'Ajuste y ensamblaje preventivo inadecuado',
        'Limpieza, pulimiento o afilado preventivo inadecuado',
        'Comunicación inadecuada de necesidades de reparación',
        'Programación del trabajo de reparación inadecuado',
        'Examen correctivo de las unidades inadecuado',
        'Reemplazo correctivo de partes inadecuado',
      ],
      'Herramientas y Equipos inadecuados': [
        'Evaluación deficiente de necesidades y riesgos',
        'Consideración inadecuada de factores humanos / ergonómicos',
        'Estándares o especificaciones inadecuados',
        'Disponibilidad inadecuada',
        'Ajuste / Reparación / Mantención deficiente',
        'Remoción y reemplazo deficiente de artículos',
      ],
      'Abuso o mal uso': ['Conducta inapropiada intencional', 'Conducta inapropiada no intencional'],
      'Estandares de trabajo inadecuados': [
        'Desarrollo inadecuado de procedimientos y normas',
        'Comunicación inadecuada de estándares en relación a publicación',
        'Distribución, traducciones al idioma propio. Entrenamiento',
        'Reforzamiento con códigos, símbolos y ayuda del trabajo',
        'Mantenimiento y monitoreo inadecuado de procedimientos, estándares y normas',
        'Monitoreo inadecuado del cumplimiento',
      ],
      'Uso y desgastes excesivos': [
        'Planificación inadecuada de uso',
        'Extensión inadecuada de la vida útil',
        'Inspección y/o control deficiente',
        'Carga o exigencias de uso inadecuadas',
        'Mantención deficiente',
        'Uso por personas no calificadas / entrenadas',
        'Uso para un propósito incorrecto',
      ],
    },
  },
};

export default incidentEnumerators;
